<template>
  <div id="ResponsiveCss">{{ ActDescBtn }}
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute;"
           width="100%">
      <tr height="48px" max-height="48px">
        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'Realizar Transferencias de productos entre almacenes.'"
                       :titulo="'Transferencias'" @MethodAnular="NotifMessage" @MethodEliminar="NotifMessage"
                       @MethodGuardar="save"
                       @MethodImprimir="findIdTransferencias(Tranferencia)" @MethodNuevo="newwnuevo" @MethodVeercuenta="vercuenta"
                       @abrirBarraTablaDinamica="abrirTabla" />
      </tr>
<!--@MethodImprimir="imprimirList"  notifImpPdf-->
      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!--------------------- aqui va la otra tabla izquierda --------->
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn>

                    <v-btn color="teal darken-2" dark small text
                           @click.prevent="dialogFiltros = true, ObjTemTbDinam = JSON.parse(JSON.stringify(Modallfiltro))">
                      <i class="fa fa-search" style="font-size: 25px;"> </i>
                      Filtrar
                    </v-btn>

                  </v-btn-toggle>
                </center>
                <!-- <v-navigation-drawer >  -->


                <!-- [
              { text: 'Código', value: 'secuencia' },
              { text: 'cliente', value: 'cliente.nombre' },
              { text: 'valor', value: 'valor' },
              { text: 'concepto', value: 'concepto' },
             /* { text: 'Nombre', value: 'nombre' },
              { text: 'Balance', value: 'balancecliente.balance' }*/
              ]
              [
              {Text:'Código',NomValue:'secuencia', Ctsl:1, Type:0, State:true},
              {Text:'Nombre',NomValue:'cliente', Nv2:'nombre', Ctsl:2, Type:0, State:true},
              {Text:'Valor $', NomValue:'valor',  Ctsl:1, Type:2, State:true},
              {Text:'concepto', NomValue:'concepto',  Ctsl:1, Type:0, State:true},
              {Text:'fecha', NomValue:'fecha',  Ctsl:1, Type:1, State:true},
              {Text:'Estado',NomValue:'activo', Ctsl:1, Type:0.1, State:true}
              ] -->

                <BarraDinamicaLimitePlus :ContListSlot="[{ Text: 'Secuencia', NomValue: 'transferenciasPK', Nv2: 'secuencia', Ctsl: 2, Type: 0, State: true },
                  { Text: 'Documento', NomValue: 'documentoinventario', Nv2: 'descripcion', Ctsl: 2, Type: 0, State: true },
                  { Text: 'Fecha', NomValue: 'nuevaFecha', Ctsl: 1, Type: 1, State: true },
                  { Text: 'hora', NomValue: 'hora', Ctsl: 1, Type: 0, State: true },
                  { Text: 'Referencia', NomValue: 'referencia', Ctsl: 1, Type: 0, State: true },
                  { Text: 'Concepto', NomValue: 'concepto', Ctsl: 1, Type: 0, State: true },
                  { Text: 'Valor $', NomValue: 'valor', Ctsl: 1, Type: 2, State: true },
                  { Text: 'Pendiente', NomValue: 'pendiente', Ctsl: 1, Type: 0.4, State: true },
                  { Text: 'Estado', NomValue: 'activada', Ctsl: 1, Type: 0.2, State: true, },
                  { Text: 'Fecha Creación', NomValue: 'nuevaFechaCreacion', Ctsl: 1, Type: 1, State: true },
                  { Text: 'Usuario Creacion ', NomValue: 'usuarioCreacion', Ctsl: 1, Type: 0, State: true },
                  { Text: 'Fecha Anulada', NomValue: 'fechaAnulacionNuevo', Ctsl: 1, Type: 1, State: true },
                  { Text: 'hora Anulación', NomValue: 'horaAnulacion', Ctsl: 1, Type: 0, State: true },
                  { Text: 'Usuario Anulación ', NomValue: 'usuarioAnulacion', Ctsl: 1, Type: 0, State: true },

                  ]" :PropsList="ListItems"
                                         :PropsNombre="'Tranferencias'" :PropsSeachNombre="'Búsqueda por código'"
                                         :TbPaginator="TbPaginator"
                                         :TbTotalItem="TbTotalItem" :headers="[
                    { text: 'Código', value: 'movimientosinventarioPK.secuencia' },
                    /* { text: 'Nombre', value: 'nombre' },
                     { text: 'Balance', value: 'balancecliente.balance' }*/
                  ]"
                                         PropsSearch @CargarPaginacion="CargarPaginacion" @EmitDAta="datostabla" />

                <!-- </v-navigation-drawer> -->
              </template>
            </v-tooltip>


          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto "
                 v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">

              <v-card color="grey lighten-3">
                <div class="px-2">

                  <v-form ref="form" v-model="valid" lazy-validation>
                    <input v-model="Tranferencia.transferenciasPK.secuencia" style="display:none;" type="number" />
                    <v-row>
                      <!-- columna 1 ------------------------------>
                      <v-col cols="12" md="5" sm="5">

                        <!------------------------------------------ Documentos -->
                        <v-combobox v-model="Tranferencia.documentoinventario" :items="filterRDocumento(RDocumento)"
                                    :rules="[rules.required]" autocomplete="off" dense
                                    item-text="descripcion" label="* Documentos:" outlined
                                    placeholder=" "
                                    style="font-size:13px;" @blur="SelctCbDocumento"
                                    @change="changeDocumento"
                                    @focus="cargarDocumento">

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                            <span v-if="item.hasOwnProperty('codigo')">
                              <span class="black--text">{{ item.descripcion }}</span>
                            </span>
                          </template>

                          <template v-slot:prepend>
                            <i class="fa fa-book" style="font-size: 20px;"></i>
                          </template>

                          <template v-slot:append-outer>

                            <v-tooltip top>
                              <template v-slot:activator="{ on }">

                                <v-btn color="green" dark fab x-small v-on="on"
                                       @click.prevent="dialogCrearDocumento = true">
                                  <i class="fa fa-plus-square" style="font-size: 20px;"></i>
                                </v-btn>

                              </template>
                              <span>Creación de documento</span>
                            </v-tooltip>


                          </template>
                        </v-combobox>

                      </v-col>
                      <!-- fn columna 1 ------------------------------>

                      <!-- columna 2 ------------------------------>
                      <v-col cols="12" md="2" sm="2">

                        <!----------------------------------------------  Fecha entrada -->
                        <v-text-field v-model="Tranferencia.fecha" :rules="[rules.required]" dense label="* Fecha:"
                                      outlined
                                      style="font-size:12px;" type="date">

                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 18px;"></i>
                          </template>
                        </v-text-field>

                      </v-col>
                      <!-- columna 2 ------------------------------>

                      <!-- columna 3 ------------------------------>
                      <v-col cols="12" md="2" sm="2">

                        <!-- Factura No --------------------------------------------------->
                        <v-text-field v-model="Tranferencia.referencia" dense label=" No. de Referencia:" outlined
                                      placeholder=" " style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                      </v-col>
                      <!-- columna 3 ------------------------------>

                      <v-col cols="12" md="3" sm="3">
                        <!-------------------------------------------------- Comentario -->
                        <v-textarea v-model="Tranferencia.concepto" autocomplete="off" dense label="* Concepto:"
                                    outlined
                                    rows="1" style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-commenting" style="font-size: 20px;"></i>
                          </template>
                        </v-textarea>
                      </v-col>

                    </v-row>
                  </v-form>

                </div>
                <v-col cols="12" md="12" sm="12" style="margin-top:-35px;">
                  <!-- Tabla De producto  ------------------------------>
                  <TablaProductoInventario ref="RefTablaProducInvent" :EntradaAlmacen="almacen" :ListProd="ListProd"
                                           :PropsTranferencia="true" @DataTotalList="DDataTotalList" />
                  <!-- fn Tabla De producto      ------------------------------>

                </v-col>
              </v-card>
            </div>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">


            <!-- <BarraBusqueda2
              :url="$hostname + $hName + '/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->


      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!-- [
      { text: "Secuencia", value: "transferenciasPK.secuencia" },
      { text: "Documento", value: "documentoinventario.descripcion" },
      { text: "Referencia", value: "referencia" },
      { text: "Concepto", value: "concepto" },
      { text: "Fecha", value: "fecha" },
      { text: "Porciento", value: "porciento" }
    ] -->

    <!-------------------------------------------------------- tb-data-->
    <v-dialog v-model="acti_tb_data" fullscreen hide-overlay label="myAlert" persistent
              transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" dense flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>
          <v-toolbar-title class="font-weight-light">
            REPORTE
          </v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="deep-purple accent-2" dark small v-on="on" @click.prevent="OpendialogimprimirListFilt()">
                <i class="fa fa-print" style="font-size: 25px;"> </i>
                Listado
              </v-btn>

            </template>
            <span>Imprimir Listado</span>
          </v-tooltip>
          <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="Modallfiltro.codigo" hide-details label="Búsqueda por código"
                            single-line @keyup.enter="CargarListTb">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
                <template v-slot:append-outer>
                  <v-btn color="teal darken-2" dark small
                         @click.prevent="dialogFiltros = true, ObjTemTbDinam = JSON.parse(JSON.stringify(Modallfiltro))">
                    <i class="fa fa-search" style="font-size: 25px;"> </i>
                    Filtros
                  </v-btn>
                </template>


              </v-text-field>
            </v-card-title>

            <v-data-table :footer-props="arrayPropiedases" :headers="[
              { text: 'Secuencia', value: 'transferenciasPK.secuencia', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Documento', value: 'documentoinventario.descripcion', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Referencia', value: 'referencia', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Concepto', value: 'concepto', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Fecha', value: 'nuevaFecha', sortable: false, class: ['no-gutters black--text'] },
              { text: 'Pendiente', value: 'pendiente', sortable: false, class: ['no-gutters black--text'] },
            ]" :items="ListItems" :items-per-page="TbPaginator.itemsPerPage" :page="TbPaginator.page"
                          :pageCount="TbPaginator.pageCount" :search="Modallfiltro.codigo"
                          :server-items-length="TbTotalItem"
                          class="TbSize13" dense @pagination="cargarPaginacionAll"
                          @click:row="datostabla">
              <template v-slot:item.valor="props">
                <span>{{ currencyFormatter(props.item.valor) }}</span>
              </template>

              <template v-slot:item.nuevaFecha="props">
                <span>{{ FormatoFecha(props.item.nuevaFecha) }}</span>
              </template>

              <template v-slot:item.pendiente="props">
                <span v-if="props.item.pendiente == true">Si</span>
                <span v-if="props.item.pendiente == false">No</span>
              </template>

            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn tb-data-->


    <!-- ------------------------------------------------------ notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'anularTranferencia'" small
                 @click.prevent="anular(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>


          <v-btn small @click.prevent="notif.estado = !notif.estado">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->


    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar id="alerMov" v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->

    <!-- ------------------------------------------------------ Modal- crear documento-->
    <v-dialog v-model="dialogCrearDocumento" max-height="80%" max-width="90%" persistent transition="fab-transition">
      <CrearDocumento @EmitCrearDocumento="RecCrearDocumento" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- crear producto-->


    <!-- ------------------------------------------------------ Modal Filtro -->
    <v-dialog v-model="dialogFiltros" label="Modal agregar factura" max-height="80%" max-width="90%"
              persistent transition="fab-transition">
      <v-card>

        <v-toolbar color="indigo" dense flat>

          <i class="" style="font-size: 20px;"> </i>
          <v-toolbar-title class="font-weight-light" style="color:white;"><b>FILTROS</b></v-toolbar-title>
          <i class="" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small
                 @click="dialogFiltros = false, Modallfiltro = JSON.parse(JSON.stringify(ObjTemTbDinam))">
            <i class="fa fa-close" style="font-size: 20px; color:white;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br>

          <v-row>


            <!-- -----------------------------  columna-1 -->
            <v-col cols="12" md="6" sm="6">

              <!----------------------------------------------  Desde -->
              <v-text-field v-model="Modallfiltro.Desde" dense label="Desde*" outlined type="date">

                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px;"></i>
                </template>
              </v-text-field>


              <!---------------------------------------------- documento -->
              <v-combobox v-model="Modallfiltro.documento" :items="RDocumento" :rules="[$rules.required]"
                          autocomplete="off" dense
                          item-text="descripcion" label="Documentos:" outlined
                          @blur="SelctCbDocumentoFiltro" @focus="cargarDocumento">
                <template v-slot:prepend>
                  <i class="fa fa-book" style="font-size: 20px;"></i>
                </template>
              </v-combobox>


            </v-col>
            <!-- ----------------------------- fn columna-1 -->

            <!-- -----------------------------  columna-2 -->
            <v-col cols="12" md="6" sm="6">

              <!-------------------------------------------------- Hasta -->
              <v-text-field v-model="Modallfiltro.Hasta" dense label="Hasta*" outlined type="date">

                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px;"></i>
                </template>

              </v-text-field>


              <v-switch v-model="Modallfiltro.pendiente" class="mt-0" color="teal" hide-details inset label="Resumido:">
                <template v-slot:label>
                  <strong v-if="Modallfiltro.pendiente == true" style="color:#000000;">pendiente: Si</strong>
                  <strong v-if="Modallfiltro.pendiente == false" style="color:#000000;">pendiente: No</strong>
                </template>
              </v-switch>


            </v-col>
            <!-- ----------------------------- fn columna-2 -->

          </v-row>


        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn-toggle class="" dense rounded>


            <v-btn color="#90A4AE" dark @click.prevent="Limpiarfiltro">
              <i class="fa fa-file-o" style="font-size: 28px;"> </i>
              Limpiar filtro
            </v-btn>

            <v-btn color="blue lighten-1" dark @click.prevent="BuscarFiltros">
              <i class="fa fa-search" style="font-size: 28px;"> </i>
              Buscar
            </v-btn>

          </v-btn-toggle>

        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-------------------------------------------------------- fn Modal filtro -->


    <!-- ------------------------------------------------------ Modal- Reportes-->
    <v-dialog v-model="dialogimprimirListFilt" label="Modal agregar cuenta" max-height="50%" max-width="80%"
              persistent transition="fab-transition">
      <!----------------------------------------------------------------- Cuerpo Reporte -->
      <v-card color="grey lighten-3">

        <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000;">

          <v-avatar size="45" tile>
            <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png">
          </v-avatar>
          <span class="font-weight-light" style="font-size: 20px;"> <b>REPORTE LISTADO DE TRANSFERENCIA</b> </span>

          <v-spacer></v-spacer>
          <v-btn color="red" fab small @click.prevent="dialogimprimirListFilt = false">
            <i class="fa fa-close" style="font-size: 20px; color:white;"></i>
          </v-btn>
        </v-toolbar>

        <hr>

        <v-container style="border: 1px solid #000000;">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
            <v-row class="pa-0 ma-0">


              <v-col cols="12" md="12" sm="12">
                <!---------------------------------------------- documento -->
                <v-combobox v-model="datosImprecionAll.documento" :items="RDocumento" autocomplete="off" dense
                            item-text="descripcion"
                            label="Documentos:" outlined @blur="SelctCbReportDocumento"
                            @focus="cargarDocumento">
                  <template v-slot:prepend>
                    <i class="fa fa-book" style="font-size: 20px;"></i>
                  </template>
                </v-combobox>

              </v-col>
              <v-col cols="12" md="6" sm="6">


                <v-text-field v-model="datosImprecionAll.desde" :rules="[$rules.required]" dense label="Desde*" outlined
                              type="date" @blur="ReportBlurDesde">

                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>

                <v-switch v-model="datosImprecionAll.Resumen" class="mt-0" color="teal" hide-details inset
                          label="Resumido:">
                  <template v-slot:label>
                    <strong v-if="datosImprecionAll.Resumen == true" style="color:#000000;">Resumido: Si</strong>
                    <strong v-if="datosImprecionAll.Resumen == false" style="color:#000000;">Resumido: No</strong>
                  </template>
                </v-switch>


              </v-col>

              <v-col cols="12" md="6" sm="6">


                <!-------------------------------------------------- Hasta -->
                <v-text-field v-model="datosImprecionAll.hasta" :rules="[$rules.required]" dense label="Hasta*" outlined
                              type="date" @blur="ReportBlurHasta">
                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>

                <v-switch v-model="datosImprecionAll.activo" class="mt-0" color="teal" hide-details inset
                          label="Resumido:">
                  <template v-slot:label>
                    <strong v-if="datosImprecionAll.activo == true" style="color:#000000;">Activo: Si</strong>
                    <strong v-if="datosImprecionAll.activo == false" style="color:#000000;">activo: No</strong>
                  </template>
                </v-switch>


              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <hr>

        <ModalReporteFiltros2 ref="ModRepfil" :Datos="datosImprecionAll" @DataReporteBasico="DDataReporteBasico" />

      </v-card>
      <!-------------------------------------------------------------------------------- Fn Cuerpo Reporte -->


    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal reportes -->


    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog v-model="dialogimprimirList" label="Modal Reporte Basico" max-height="50%" max-width="80%"
              persistent transition="fab-transition">


      <ModalReporteBasico ref="RefComponentsModRepBas" :Datos="datosImprecion" @DataReporteBasico="DDataReporteBasico" />

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->

    <!-- ------------------------------------------------------ Modal- agregar cuenta-->
    <v-dialog v-model="acti_Modal_cuenta" label="Modal agregar cuenta" max-height="50%" max-width="80%"
              persistent transition="fab-transition">

      <CuentasContables :RLisCuenta="RLisCuenta" :Total="TotalCuenta" :objeTem="objeTem"
                        @CuentasContables="CCuentasContables" />

    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal agregar cuenta-->

    <!-- ------------------------------------------------------ Modal- verificar producto -->
    <v-dialog v-model="dialogVerificaProducto" label="Modal verificar producto" max-height="80%" max-width="90%"
              persistent transition="fab-transition">

      <v-card>

        <v-toolbar color="indigo" dense flat>

          <i class="" style="font-size: 20px;"> </i>
          <v-toolbar-title class="font-weight-light" style="color:white;"> VERIFICACIÓN DE EXISTENCIA PRODUCTO
          </v-toolbar-title>
          <i class="" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="dialogVerificaProducto = false">
            <i class="fa fa-close" style="font-size: 20px; color:white;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-col class="pa-0 ma-0 py-0 my-0 pt-2" cols="12" md="12" sm="12">
            <div style="border: 1px solid #000000;">
              <v-data-table v-if="dialogVerificaProducto" id="TbBord" :footer-props="arrayPropiedases"
                            :headers="[
                  { text: 'PRODUCTO', sortable: false, value: 'producto.descripcion', width: 'auto', class: ['no-gutters black--text'] },
                  { text: 'CANTIDAD', sortable: false, value: 'poscantidad', width: 'auto', class: ['no-gutters black--text'] },
                  { text: `EXISTENCIA(${Tranferencia.documentoinventario.almacenOrigen.descripcion.trim()})`, sortable: false, value: 'existencia', width: 'auto', class: ['no-gutters black--text'] },
                  { text: 'ACCIÓN', sortable: false, value: 'action', width: 'auto', class: ['no-gutters black--text'] },
                ]" :items="listDatosVerificar(ListProd)" class="elevation-1 RowSelectColor TbSize13" dense
                            item-key="indx">


                <template v-slot:item.producto.descripcion="props">
                  <!-- <span style="font-size:13px;" >{{props.item.producto.descripcion}}</span> -->
                  <v-text-field v-if="props.item.producto != null" id="formdisabledInput"
                                :value="props.item.propsDesProdUnid"
                                autocomplete="off" dense disabled hide-details label="" outlined
                                style="font-size:13px;">
                  </v-text-field>
                </template>

                <template v-slot:item.poscantidad="props">
                  <span style="display:none;">{{ props.item.poscantidad = props.item.cantidad }} </span>
                  <AutoNumeric v-model.number="props.item.poscantidad" autocomplete="off" dense hide-details label=""
                               outlined
                               style="font-size:13px;"
                               @blur="posCantidadListExist(props.item, props.item.poscantidad)">
                  </AutoNumeric>
                </template>

                <template v-slot:item.existencia="props">
                  <!-- <span>{{props.item.existencia}}</span> -->
                  <v-text-field id="formdisabledInput" :value="props.item.existencia" autocomplete="off" dense disabled
                                hide-details
                                label="" outlined style="font-size:13px;">
                  </v-text-field>
                </template>


                <template v-slot:item.action="{ item }">
                  <v-btn color="red darken-3" fab x-small @click.prevent="eliminarItem(item)"><i
                    class="fa fa-trash-o" style="font-size: 20px;"></i></v-btn>
                </template>

              </v-data-table>

            </div>
          </v-col>

        </v-card-text>
      </v-card>


    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- verificar producto -->

    <!-- ------------------------------------------------------ Modal- Notificacion Confirmacion Adicional -->
    <v-dialog transition="fab-transition" label="Modal Otros Ingresos" v-model="notifConfAdicional.estado" persistent
      max-width="60%" max-height="85%">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

     
        <v-col style="background-color:#dd4b39;" class="pa-2 ma-0 py-1 my-0" cols="12" md="12" sm="12">
            <span style="font-size: 22px;"  :class="`d-flex justify-start white--text`"> <i dense class="fa fa-info-circle"> <b> NOTIFICACIÓN</b></i></span>
         </v-col>
        
        <v-card >
          <!-- style="border: 1px solid #000000;" -->
          <!-- columna informacion  -->
          <v-col style="border: 1px solid #000000;"   class="pa-0 ma-0 py-2 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
            <center >
            <!-- <h2 class="py-5">  </h2> -->
              <code :class="`black--text`" style=" font-size: 25px;border: 1px solid #000000;">
              <b>{{ notifConfAdicional.nombre }}</b>
              </code>

              <v-col v-if="notifConfAdicional.Exec == 'contImpPdf'"  class="pa-0 ma-0 py-1 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
                <!-------------------------------------------------- terminal -->
                        <!--:items="RSuplidor",@blur="SelctCbSuplidor", @focus="cargarSuplidor", @keyup="CbFilSuplidor" -->
                        <v-combobox autocomplete="off" dense outlined label="* Seleccione Impresora:" item-text="nombre"
                          :items="impList" @focus="cargarImpresoras" v-model="notifConfAdicional.Impresora"
                          hide-details @blur="SelctCbImpresora">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-trademark"></i>
                          </template>
                        </v-combobox>
              </v-col>
                <!--anularFactura(notifConfAdicional.objTemp)  -->
                <v-card-actions :class="`d-flex justify-center`">
                  
                <v-btn style="border: 1px solid #000000;"  color="blue" v-if="notifConfAdicional.Exec == 'contImpPdf'"
                  @click.prevent="imprimirPrint()" large>
                  <i style="font-size: 20px;" class="fa fa-print"></i> IMPRIMIR
                </v-btn>

                <v-btn style="border: 1px solid #000000;"  color="#BDBDBD" v-if="notifConfAdicional.Exec == 'contImpPdf'" 
                @click.prevent="reportePdf()" large>
                  <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i> REPORTE PDF
                </v-btn>

                <v-btn style="border: 1px solid #000000;"  color="orange" 
                @click.prevent="cerrarNotificacion" large>
                  <i style="font-size: 20px;" class="fa fa-reply-all"></i> CERRAR
                </v-btn>
                </v-card-actions>

          
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
     <!-- ------------------------------------------------------ FIN Modal- Notificacion Confirmacion Adicional  -->





    <!---------------------  Panel Menu Opcion Botones ------------------------------->
    <div style="max-height:300px;" class="overflow-x-auto" v-show="false">
      <!-- columna  ---------------------->
      <PvMenuOpcionBotones ref="RefPvMenuOpcionBotones" @DataRetornAccion="DataRetornMenuOpcBotonesPermisosPv"
        @DataRetornAccionPadre="DataRetornPadrePermisoPv" />
    </div>


    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>

</template>

<script>
import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
import CrearDocumento from "../../Inventario/UtilidadComponents/CrearDocumento"
import AutoNumeric from "../../components/AutoNumericNuevo"
import { EventBus } from "../../event-bus"
import ContenidoBase from "../../components/ContenidoBase"
import ModalReporteFiltros from "../../components/ModalReporteFiltros"
import ModalReporteBasico from "../../components/ModalReporteBasico"
import ModalReporteFiltros2 from "../../components/ModalReporteFiltros2"
import CuentasContables from "../../components/CuentasContables"
import { currencyFormatter, fechaNueva, FormatoFecha, HoraFormatter, RedondeoBasico } from "@/js/Funciones.js"
import TablaProductoInventario from "../../Inventario/UtilidadComponents/TablaProductoInventario"
import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus"
import PvMenuOpcionBotones from "@/PuntodeVenta/UtilidadComponents/PvMenuOpcionBotones.vue";

export default {
  components: {
    AutoNumeric,
    BarraBusqueda2,
    CrearDocumento,
    ContenidoBase,
    ModalReporteFiltros,
    ModalReporteBasico,
    CuentasContables,
    TablaProductoInventario,
    BarraDinamicaLimitePlus,
    ModalReporteFiltros2,
    PvMenuOpcionBotones
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    //EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    //EventBus.$on("emitTransferencias", this.datostabla);
    EventBus.$on("onResize", this.onResize)
    this.filtro()
    this.findAlmacenPrincipal()
  },

  created() {
    var json = {
      titulo: "Transferencias",
      descripcion: "Realizar Transferencias de productos entre almacenes.",
      save: true,
      eliminar: true,
      anular: false,
      nuevo: true,
      imprimir: false,
      vercuenta: true,

      accion: [
        "INVTransferenciasNew",
        "INVTransferenciasSave",
        "INVTransferenciasRemove",
        "INVTransferenciasAnular",
        "INVTransferenciasPrintList",
        "INVTransferenciasVercuenta",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  data() {
    return {
      impList:[],
      notifConfAdicional: {
      estado: false,
      nombre: "",
      Exec: "",
      Impresora:null,
      objTemp:null
    },
      windowSize: { width: "auto", height: "auto" },
      valid: true,
      ejecucion: true,
      EjecutarPermisoPv:false,
      dialogOrdenSugerida: false,
      dialogCrearDocumento: false,
      dialogVerificaProducto: false,
      Rmoneda: [],
      RallProducto: [],
      Rdepartamento: [],
      RDocumento: [],
      dialogimprimirList: false,
      datosImprecion: {
        nombre: "TRANSFERENCIAS",
        UrlImprimir: "/transferenciasInv/imprimir",
        UrlExel: "/transferenciasInv/excel",
        UrlCorreo: "/transferenciasInv/correo",
      },
      dialogimprimirListFilt: false,
      datosImprecionAll: {
        nombre: "LISTADO DE TRANSFERENCIAS",
        UrlImprimir: "/transferenciasInv/ImprimirList",
        UrlExel: "/transferenciasInv/ExcelList",
        UrlCorreo: "/transferenciasInv/CorreoList",
        documento: null,
        desde: fechaNueva(),
        hasta: fechaNueva(),
        sucursal: null,
        Resumen: true,
        activo: true,
      },
      aalert: {
        estado: false,
        color: null,
      },
      notif: {
        estado: false,
        nombre: "",
        Exec: "",
      },
      search: "",
      ObjTemp: null,
      objeTem: null,
      TotalCuenta: null,
      contabilidad: null,
      TotalProd: { cantidad: 0, cantExit: 0, costo: 0, impuesto: 0, descuento: 0, importe: 0 },
      ListProd: [],
      almacen: null,
      OrdenSugerida: {
        desde: fechaNueva(),
        hasta: fechaNueva(),
        dia: 0,
        proveedor: null,
        almacen: null,
        opcion: 1,
      },
      Tranferencia: {
        transferenciasPK: { secuencia: 0, documento: 0 },
        fecha: fechaNueva(),
        concepto: "",
        tasa: 1,
        documentoinventario: null,
        empresa: 1,
        referencia: "",
        pendiente: true,
        bulto: 0,
        borrado: false,
        transferenciasDetalleList: [],
        usuarioAnulacion: null,
        fechaAnulacion: null,
        horaAnulacion: null,
      },
      RLisCuenta: [],
      TotalCuenta: {
        credito: 0,
        debito: 0,
      },
      acti_Modal_cuenta: false,
      RLisCuenta: [],
      TotalCuenta: {
        credito: 0,
        debito: 0,
      },

      dialogFiltros: false,
      Modallfiltro: {
        codigo: null,
        documento: null,
        Desde: null,
        Hasta: null,
        pendiente: false,
      },

      ObjTemTbDinam: null,
      ListItems: [],
      TbTotalItem: 0,
      TbPaginator: {
        page: 1,
        itemsPerPage: 5,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },
      arrayPropiedases: {
        "items-per-page-options": [10, 15, 20, 50],
        "items-per-page-text": "Cantidad de Registros Por Paginas",
        showFirstLastPage: false,
      },
      EstadoBtn: {
        BarraTablaDinamicaAprir: true,
        nuevo: true,
        guardar: true,
        eliminar: false,
        anular: false,
        imprimir: true,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },
      TipoProveedor: {
        codigo: 0,
        nombre: null,
        porciento: 0,
      },


      rules: {
        required: value => !!value || "Required.",
        edad: [
          val => val > 10 || `Edad debe ser mayor a 10`,
          val => val < 70 || `Edad debe ser menor a 120`,
        ],
        porciento: value => value <= 100 || `Porciento debe ser  menor a 100`,
        counter: value => (value && value.length <= 50) || "Max 20 characters",
        RTel: value => value != 10 || `telefono debe tener 10 digitos`,
      },
      headers: [{ text: "Tarjeta", value: "nombre" }],
      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        { dt0: "nombre", dt1: null, dt2: null, dt3: 1, dt4: "nombre:" },
        { dt0: "porciento", dt1: null, dt2: null, dt3: 5, dt4: "Porciento:" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,
    }
  },
  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    fechaNueva,
    RedondeoBasico,
    onResize(e) {
      // this.windowSize=e
    },
    findAlmacenPrincipal() {
      this.$axios.get(this.$hostname + this.$hName + "/almacen/principal", { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.almacen = res.data
        })
    },
    RecCrearDocumento(e) {
      this.dialogCrearDocumento = e.estado
    },

    cargarDocumento() {
      this.$axios.get(this.$hostname + this.$hName + "/documento-inv/transferencia", { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumento = res.data))
    },
    SelctCbDocumento() {
      if (this.Tranferencia.documentoinventario == null) {
        this.Tranferencia.documentoinventario = ""
      }
      if (this.Tranferencia.documentoinventario.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.Tranferencia.documentoinventario = ""
        return
      }
      this.almacen = this.Tranferencia.documentoinventario.almacenOrigen
    },

    changeDocumento(e) {

      var _this = this
      setTimeout(function() {
        if (e == null) {
          return
        }

        if (!e.hasOwnProperty("codigo")) {
          return
        }

        if (_this.ListProd.filter(r => r.producto != null).length > 0) {
          _this.$refs.RefTablaProducInvent.AddExistenciaProductosList(e.almacenOrigen)
          // AddExistenciaProductosList,AddExistenciaProductosList
        }

      }, 300)

    },

    eliminarItem(e) {
      this.$refs.RefTablaProducInvent.eliminarItem(e)
    },

    posCantidadListExist(item, value) {
      item.cantidad = JSON.parse(JSON.stringify(value))
    },


    DDataTotalList(e) {

      var _this = this
      setTimeout(function() {
        _this.TotalProd = JSON.parse(JSON.stringify(e))
      var ObjProRowNew = _this.ListProd.filter((ee) => ee.producto==null)
      var ObjProRow = _this.ListProd.filter((ee) => ee.producto!=null && ee.producto.hasOwnProperty('codigo') && ee.unidad!=null && ee.unidad.hasOwnProperty('codigo'));
      const resultado = Object.values(
        ObjProRow.reduce((acc, item) => {
      const key = `${item.producto.codigo}-${item.unidad.codigo}`;
      if (!acc[key]) {
        // clonamos el objeto completo
          acc[key] = { ...item };
      } else {
          acc[key].cantidad += item.cantidad;
      }
      return acc;
    }, {})
  );

    if(ObjProRowNew.length>0){
      ObjProRowNew = ObjProRowNew.slice(0, 1);
    }
      _this.ListProd=resultado.concat(ObjProRowNew)
      
      }, 300)

    //  _this.RedireccionBlur('codigo' + e.indx)

    },

    listDatosVerificar(list) {
      return list.filter((ee) => ee.unidadProducto != null && ee.cantidad > ee.existencia)
    },


    save() {
      EventBus.$emit("loading", true)
      if (this.ListProd.filter(r => r.producto != null).length == 0) {
        this.alerta("Debe elegir almenos un producto para la transferencia", "error")
        return
      }

      if (this.$refs.form.validate()) {

        var BOOL_PERMITIR = this.$store.getters.GetConfiguracionGeneral.configInv.permitirNegativos
        if (BOOL_PERMITIR) {
          this.saveContinuar()
        } else {
          // var OBJ_TRANSF=JSON.parse(JSON.stringify(this.Tranferencia))
          var ObjProRow = this.ListProd.filter((ee) => ee.unidadProducto != null && ee.cantidad > 0 && ee.cantidad > ee.existencia)
          if (ObjProRow.length > 0) {
            this.alerta("Productos que excede la existencia", "error")
            this.dialogVerificaProducto = true
            console.log(ObjProRow)
          } else {
            this.saveContinuar()
          }
        }
      } else {
        this.alerta("los campos en rojo son Requeridos", "error")
      }

    },


    saveContinuar() {

      this.Tranferencia.transferenciasDetalleList = []
      var det = {}

      var bar = new Promise((resolve, reject) => {
        this.ListProd.filter(r => r.producto != null && r.cantidad > 0).forEach(el => {
          det = {
            transferenciasDetallePK: { documento: 0, secuencia: 0, producto: 0, unidad: 0 },
            unidades: el.unidad,
            productos: el.producto,
            almacendestino: this.Tranferencia.documentoinventario.almacenDestino,
            almacenorigen: this.Tranferencia.documentoinventario.almacenOrigen,
            impuesto: el.impuesto,
            costo: el.costo,
            cantidad: el.cantidad,
            valor: el.valor,
            lote: el.lote,
            fechavencimiento: new Date(el.fechavencimiento).toISOString().split("T")[0] + "T04:00",
            borrado: false,
          }
          this.Tranferencia.transferenciasDetalleList.push(det)
        })

        resolve()
      })

      bar.then(() => {
        console.log("All done Procesar save!")
        this.Tranferencia.contabilidad = this.contabilidad
        if (this.RLisCuenta.length > 0) {
          this.Tranferencia.contabilidad.contabilidadDetalleList = this.RLisCuenta
        }

        if (this.ejecucion == true) {
          this.ejecucion = false
          EventBus.$emit("loading", true)

          if (this.Tranferencia.transferenciasPK.secuencia == 0) {
            this.Tranferencia.usuarioCreacion = this.$store.getters.GetdatosInfUsu.usuario.usuario
            this.Tranferencia.fechaCreacion = this.fechaNueva() + "T04:00"
          }

          this.$axios
            .post(
              this.$hostname + this.$hName + "/transferenciasInv/save", this.Tranferencia,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then(res => {
                this.alerta("Dato guardado correctamente", "bien")
                var _this = this
                setTimeout(function() {
                  _this.findIdTransferencias(res.data)
                  }, 300)
            } )
            .catch(error => {
              if (error.response) {
                this.alerta(error.response.request.responseText, "error")
              } else {
                this.alerta(error, "error")
              }
            })
        }
      })


      /* if (this.ListProd.filter(r => r.producto != null).length == 0) {
              this.alerta("Debe elegir almenos un producto para la transferencia", "error")
            }
      
            if (this.$refs.form.validate()) {
            } else {
              this.alerta("los campos en rojo son Requeridos", "error");
            }*/


    },


    NotifMessage() {

      if (this.Tranferencia.transferenciasPK.secuencia != 0 && this.Tranferencia.transferenciasPK.secuencia != null) {

        var notif = {
          estado: true,
          nombre: "¿Seguro que desea Anular este registro?",
          Exec: "anularTranferencia",
        }

        this.Exec_notif(notif)


      } else {
        this.alerta("Seleccione una tranferencia para Anular", "error")
      }


    },
    Exec_notif(e) {
      this.notif = JSON.parse(JSON.stringify(e))
    },
    eliminar() {

    },

anular(){
      if (this.EjecutarPermisoPv == false) {
          this.ObjEjecPermisoPv = JSON.parse(JSON.stringify(this.Tranferencia))
          this.funcionValidaPermisoPv('AccAnularInvTransferencia')
          return;
        }
    },


    contAnulacion() {


      if (this.$refs.form.validate()) {
        if (this.ejecucion == true) {
          this.ejecucion = false
          EventBus.$emit("loading", true)

         /* this.Tranferencia.usuarioAnulacion = this.$store.getters.GetdatosInfUsu.usuario.usuario
          this.Tranferencia.fechaAnulacion = this.fechaNueva() + "T04:00"
          this.Tranferencia.horaAnulacion = ""*/

          this.$axios
            .post(
              this.$hostname + this.$hName + "/transferenciasInv/anular", this.Tranferencia,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then(res => this.alerta("Dato guardado correctamente", "bien"))
            .catch(error => this.alerta(error, "error"))
        }
      } else {
        this.alerta("los campos en rojo son Requeridos", "error")
      }
    },

    imprimirList() {
      if (this.Tranferencia.transferenciasPK.secuencia > 0) {
        this.datosImprecion.secuencia = this.Tranferencia.transferenciasPK.secuencia
        this.datosImprecion.documento = this.Tranferencia.transferenciasPK.documento
        this.datosImprecion.almacen = this.Tranferencia.documentoinventario.almacenOrigen.descripcion

        //          ic.imprimir("Comprobante_transferencia_producto", parametros, "inv");

        this.dialogimprimirList = true
      } else {
        this.alerta("Seleccione un tranferencia para poder imprimir", "error")
      }
    },

    DDataReporteBasico(e) {
      this.dialogimprimirList = e
    },

    OpendialogimprimirListFilt() {
      this.dialogimprimirListFilt = true
      var _this = this
      setTimeout(function() {
        _this.$refs.ModRepfil.CrearObjecto = _this.validarObjecto
      }, 300)

    },


    validarObjecto() {
      //this.datosImprecionAll.tenant=this.datosImprecion.schema=this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      console.log("ver-Desde-->", this.datosImprecionAll.desde)
      console.log("ver-Hasta-->", this.datosImprecionAll.hasta)
      var condicion = `DESDE: ${this.FormatoFecha(this.datosImprecionAll.desde)}                HASTA: ${this.FormatoFecha(this.datosImprecionAll.hasta)}`


      var where = `t.pendiente=false AND t.activada=${this.datosImprecionAll.activo} `
      //where += ` and t.fecha>= ' ${new Date(this.datosImprecionAll.desde).toISOString().substr(0, 10)}' and t.fecha<= ' ${new Date(this.datosImprecionAll.hasta).toISOString().substr(0, 10)} ' `
      where += ` and t.fecha>= '${this.datosImprecionAll.desde}' and t.fecha<= '${this.datosImprecionAll.hasta}' `
      // this.datosImprecionAll.documento = ""

      if (this.datosImprecionAll.documento != null && this.datosImprecionAll.documento.hasOwnProperty("codigo")) {
        where += ` and t.documento= ${this.datosImprecionAll.documento.codigo}`
        condicion += `\t DOCUMENTO: ${this.datosImprecionAll.documento.descripcion.trim()}`
      }
      this.datosImprecionAll.where = where

    condicion+=`\t ESTADO: ${this.datosImprecionAll.activo==true?'ACTIVOS' : 'ANULADOS'}`

      this.datosImprecionAll.condicion = condicion
      //        ic.imprimir("ListadoTransferencia2", parametros, "inv");


    },


    newwnuevo() {

      this.BarraTablaDinamicaAprir = false
      this.contabilidad = null
      this.RLisCuenta = []

      this.TipoProveedor = {
        codigo: 0,
        nombre: null,
        porciento: 0,
      }
      this.Tranferencia = {
        transferenciasPK: { secuencia: 0, documento: 0 },
        fecha: fechaNueva(),
        concepto: "",
        tasa: 1,
        documentoinventario: null,
        empresa: 1,
        referencia: "",
        pendiente: true,
        bulto: 0,
        borrado: false,
        transferenciasDetalleList: [],
        usuarioAnulacion: null,
        fechaAnulacion: null,
        horaAnulacion: null,
      }
      this.TotalProd = { cantidad: 0, cantExit: 0, costo: 0, impuesto: 0, descuento: 0, importe: 0 }
      this.ListProd = []
      this.ejecucion = true
      EventBus.$emit("actualizaBarraBusqueda2")
      EventBus.$emit("loading", false)

      this.$refs.RefTablaProducInvent.TotalProd = {
        cantidad: 0,
        cantExit: 0,
        costo: 0,
        impuesto: 0,
        descuento: 0,
        importe: 0,
      }


    },
    datostabla(e) {
      this.contabilidad = null
      this.RLisCuenta = []
      this.ListProd = []
      this.Tranferencia = e
      //this.Tranferencia.fecha = new Date(e.fecha).toJSON().split("T")[0]
      this.Tranferencia.fecha = e.nuevaFecha
      e.transferenciasDetalleList.forEach(e => {

        var detalle = {
          movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
          fechavencimiento: null,
          cantidad: e.cantidad,
          costo: e.costo,
          valor: e.valor,
          impuesto: e.impuesto,
          impuestoIncluido: e.impuestoIncluido,
          existencia: 0,
          id: 0,
          borrado: false,
          almacen: this.Tranferencia.documentoinventario.almacenOrigen,
          unidad: e.unidades,
          producto: e.productos,
          codigoProducto: "",
          unidadProducto: null,
        }

        this.$refs.RefTablaProducInvent.getUnidadesProductosAddList(e.productos.codigo, e.unidades.codigo, detalle)

      })
      this.acti_tb_data = false
      //console.log(e);


      var _this = this
      setTimeout(function() {
        _this.$refs.RefTablaProducInvent.calcularTotales()
        _this.getCrearCont()
      }, 500)


    },


    FiltroBlurDesde() {
      if (this.Modallfiltro.Desde.toString().length == 0) {
        this.Modallfiltro.Desde = this.fechaNueva()
      }
    },


    FiltroBlurHasta() {
      if (this.Modallfiltro.Hasta.toString().length == 0) {
        this.Modallfiltro.Hasta = this.fechaNueva()
      }
    },

    SelctCbDocumentoFiltro() {
      if (this.Modallfiltro.documento == null) {

        this.Modallfiltro.documento = ""
      }

      if (this.Modallfiltro.documento.codigo == undefined) {

        this.alerta("Seleccione un documento", "error")
        this.Modallfiltro.documento = ""
        return

      }

    },


    SelctCbReportDocumento() {

      if (this.datosImprecionAll.documento == null) {
        this.datosImprecionAll.documento = ""
      }

      if (this.datosImprecionAll.documento.codigo == undefined) {
        //this.alerta("Seleccione un documento", "error");
        this.datosImprecionAll.documento = ""
        return
      }

    },


    ReportBlurDesde() {
      if (this.datosImprecionAll.desde.toString().length == 0) {
        this.datosImprecionAll.desde = this.fechaNueva()
      }

    },


    ReportBlurHasta() {

      if (this.datosImprecionAll.hasta.toString().length == 0) {
        this.datosImprecionAll.hasta = this.fechaNueva()
      }

    },


    getCrearCont() {
      console.log("Entrando A generar")
      if (this.TotalProd.importe == 0) {
        return
      }
      if (this.$refs.form.validate()) {

        if (this.Tranferencia.transferenciasPK.secuencia == 0) {
          this.$axios.get(this.$hostname + this.$hName + "/contabilidad/crear-contabilidad-inv/" + this.Tranferencia.documentoinventario.codigo + "/" + this.TotalProd.importe + "/" + this.TotalProd.impuesto + "/0",
            { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
              this.llenarcuenta(res.data)
            })
        }
        if (this.Tranferencia.transferenciasPK.secuencia != 0) {
          this.$axios.get(this.$hostname + this.$hName + "/contabilidad/findContabilidad/" + this.Tranferencia.transferenciasPK.documento + "/" + this.Tranferencia.transferenciasPK.secuencia + "/" + this.Tranferencia.documentoinventario.operacion.codigo,
            { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
              this.llenarcuenta(res.data)
            })
        }
      }
    },
    llenarcuenta(e) {
      console.log(e)
      if (e.toString().trim().length == 0) {
        return
      }

      if (this.contabilidad === null) {
        this.contabilidad = e
        this.contabilidad.fecha = this.Tranferencia.fecha
        this.contabilidad.documento = this.Tranferencia.documentoinventario.codigo
      }


      this.RLisCuenta = JSON.parse(JSON.stringify(e.contabilidadDetalleList))
      this.RLisCuenta = this.RLisCuenta
      this.objeTem = JSON.parse(JSON.stringify(this.RLisCuenta))
      this.calcularTotalcuenta(1)
    },
    async calcularTotalcuenta(e) {
      this.TotalCuenta.credito = 0
      this.TotalCuenta.debito = 0

      if (e.toString().length > 0) {

        await Promise.all(this.RLisCuenta.map(async (element) => {
          this.TotalCuenta.credito += this.RedondeoBasico(element.credito)
          this.TotalCuenta.debito += this.RedondeoBasico(element.debito)
        }))

      }

      /*  if (e.toString().length > 0) {
          this.RLisCuenta.forEach(element => {
            this.TotalCuenta.credito += element.credito
            this.TotalCuenta.debito += element.debito
          });
        }*/
    },


    CCuentasContables(e, t, b) {
      if (e != undefined) {

        if (e.length == 0) {

          this.getCrearCont()

        } else {
          this.RLisCuenta = JSON.parse(JSON.stringify(e))
          this.TotalCuenta = JSON.parse(JSON.stringify(t))
        }
      }

      this.RLisCuenta = JSON.parse(JSON.stringify(e))
      this.RLisCuenta = this.RLisCuenta
      this.TotalCuenta = JSON.parse(JSON.stringify(t))

      this.acti_Modal_cuenta = b

    },


    vercuenta() {


      if (this.$refs.form.validate()) {
        if (this.RLisCuenta.length == 0) {
          this.getCrearCont()
        }
        this.objeTem = JSON.parse(JSON.stringify(this.RLisCuenta))
        this.TotalCuenta = JSON.parse(JSON.stringify(this.TotalCuenta))
        this.calcularTotalcuenta(1)
        // setTimeout(this.acti_Modal_cuenta=!this.acti_Modal_cuenta,200);

        this.acti_Modal_cuenta = !this.acti_Modal_cuenta

      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }

    },

    abrirTabla2() {
      // console.log("entro");
      this.BarraSecundariaAprir = !this.BarraSecundariaAprir
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      if (this.BarraTablaDinamicaAprir == true) {
        this.Limpiarfiltro()
      }
    },

    actualiza_tb_ver() {

      this.acti_tb_data = !this.acti_tb_data
      this.Limpiarfiltro()

    },

    Limpiarfiltro() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      this.Modallfiltro = {
        pendiente: false,
        codigo: null,
        documento: null,
        Desde: null,
        Hasta: null,
      }


      this.ListItems = []
      this.TbTotalItem = 0

      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false

    },

    BuscarFiltros() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      if (this.Modallfiltro.codigo != null && this.Modallfiltro.codigo.toString().length == 0) {
        this.Modallfiltro.codigo = null
      }

      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false

    },


    cargarPaginacionAll(e) {

      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      this.CargarPaginacion(e, this.Modallfiltro.codigo)
    },

    CargarPaginacion(e, s) {

      this.Modallfiltro.codigo = JSON.parse(JSON.stringify(s))

      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      //var pg =
      this.TbPaginator = JSON.parse(JSON.stringify(e))
      this.CargarListTb()

    },

    CargarListTb() {

      if (this.Modallfiltro.codigo != null && this.Modallfiltro.codigo.toString().length == 0) {
        this.Modallfiltro.codigo = null
      }

      var doc = null
      if (this.Modallfiltro.documento != null) {
        doc = this.Modallfiltro.documento.codigo
      }
      var obj = this.TbPaginator.itemsPerPage + "/" + this.TbPaginator.pageStart + "/" + this.Modallfiltro.codigo + "/" + doc + "/" + this.Modallfiltro.pendiente + "/" + this.Modallfiltro.Desde + "/" + this.Modallfiltro.Hasta
      this.$axios.get(this.$hostname + this.$hName + "/transferenciasInv/findListTransferenciaPlus/" + obj, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.ListItems = res.data.ListItems, this.TbTotalItem = res.data.TbTotalItem
        })
    },



    // Llamar a una función en un componente secundario para los permisos de usuario.
    funcionValidaPermisoPv(e) {
      var Sudo = this.$store.getters.GetdatosInfUsu.usuario.sudo
      var permiso = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList

      //if (Sudo == false) { }
      var obj = {
        accion: JSON.parse(JSON.stringify(e)),
        Permiso: permiso,
        Sudo: Sudo
      }
      this.$refs.RefPvMenuOpcionBotones.ClickAccionPadreEjecut(obj)
    },

    DataRetornMenuOpcBotonesPermisosPv(e) {

    },

    DataRetornPadrePermisoPv(e) {
   
if (e == 'AccAnularInvTransferencia') {
        this.EjecutarPermisoPv = true
        var _this = this;
        var OBJDATA = JSON.parse(JSON.stringify(this.ObjEjecPermisoPv))
        this.ObjEjecPermisoPv = null
        setTimeout(function () {
           _this.Tranferencia.usuarioAnulacion = JSON.parse(sessionStorage.getItem("usuarioAutorizacion"))
           _this.Tranferencia.fechaAnulacion = _this.fechaNueva() + "T04:00"
          _this.contAnulacion();
          _this.EjecutarPermisoPv = false
        }, 500);
        return;
      }


    },


findIdTransferencias(DATA){
  /*var OBJ={
      transferenciasPK:{secuencia: 41, documento: 11}
    }
    this.findIdTransferencias(OBJ)*/
  var link=`/transferenciasInv/find/${DATA.transferenciasPK.secuencia}/${DATA.transferenciasPK.documento}`
  this.$axios.get(this.$hostname + this.$hName + link, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.datostabla(res.data)
          this.notifImpPdf(res.data)
        })

} ,


 notifImpPdf(notifConfAdicional){
        this.notifConfAdicional= {
      estado: true,
      nombre: `\n¿Desea Imprimir o generar PDF?`,
      Exec: "contImpPdf",
      objTemp: notifConfAdicional,
    }

    return
      },



cerrarNotificacion(){
this.notifConfAdicional= {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    }
},

reportePdf(){
  this.imprimirList()
  // var _this = this
  //       setTimeout(function () {
  //         _this.$refs.RefComponentsModRepBas.ReporteImprimir()
  //         _this.dialogimprimirList = false
  //       }, 100)
},

SelctCbImpresora() {
      var _this = this
      setTimeout(function() {
        if (_this.notifConfAdicional.Impresora == null) {
          _this.notifConfAdicional.Impresora = ""
        }

        if (!_this.notifConfAdicional.Impresora.hasOwnProperty("codigo")) {
          _this.notifConfAdicional.Impresora = ""
          _this.notifConfAdicional.Impresora = null
          return
        }
      }, 300)

    },

async imprimirPrint(){

if(this.notifConfAdicional.Impresora==null){
  this.alerta("Seleccione una Impresora", "error")
  return
}
  
var User = ""
      if (this.$store.getters.GetdatosInfUsu.usuario.nombre == null) {
        User = this.$store.getters.GetdatosInfUsu.usuario.username
      } else {
        User = this.$store.getters.GetdatosInfUsu.usuario.nombre
      }
// Promise.all(RObjProductoCompra.map(async (element) => { }))
var arraysList=[]
await Promise.all(this.notifConfAdicional.objTemp.transferenciasDetalleList.map(async (element) => { 
  var OBJ={
  titulo:"COMPROBANTE DE TRANSFERECIA",
  fecha:this.FormatoFecha(this.datosImprecionAll.desde),
  numTrasf:`${this.notifConfAdicional.objTemp.documentoinventario.nombrecorto.trim()}-${this.notifConfAdicional.objTemp.transferenciasPK.secuencia}`,
  referencia:this.notifConfAdicional.objTemp.referencia!=null?this.notifConfAdicional.objTemp.referencia.trim():'',
  almOrigen:element.almacenorigen!=null?element.almacenorigen.descripcion.trim():"",
  almDestino:element.almacendestino!=null?element.almacendestino.descripcion.trim():"",
  codpro:element.productos.codigo,
  producto:`${element.productos.descripcion.trim()}(${element.unidades.descripcion.trim()})`,
  cantidad:element.cantidad,
  usuario:User
}
arraysList.push(OBJ)
}))
//  

var Obj = {
  accion: "print",
  formato: "rolloT",
  data:this.$store.getters.GetConfiguracionGeneral,
  datostranf:arraysList,
  Impresora:this.notifConfAdicional.Impresora
}

this.imprimir(Obj, "tranfInventario");
},

imprimir(datos, operacion) {
      EventBus.$emit("loading", true)
      datos.operacion = operacion
      this.$axios
        .post("http://localhost:15999/impresora/imprimir", datos)
        .then((res) => {
          EventBus.$emit("loading", false)
          //this.limpiarPuntoVentaCompleto();
        })
        .catch((error) => {
          EventBus.$emit("loading", false)
          console.error(error)
        })

    },


    cargarImpresoras() {
      var header = {
        mode: "no-cors",
        header: {
          "Access-Control-Allow-Origin": "*",
          "origin": "x-requested-with",
          "Access-Control-Allow-Headers": "POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin",
          "Content-Type": "application/json",
        },
      }
      this.$axios
        .get("http://localhost:15999/impresora/inicial/listaImpresora", header)
        .then((res) => {
          if (res.data.length > 0) {
            this.impList = res.data[0].impresoras
            //this.form.imprimirEtiqueta.Impresora = res.data[0].defaulPrinter;
          }
        })
    },

     filterRDocumento(RDocumento){

      var V_USU=this.$store.getters.GetdatosInfUsu.usuario;
      if(V_USU.hasOwnProperty('sucursal') && V_USU.sucursal!=null && V_USU.sucursal.hasOwnProperty('codigo')){
        return RDocumento.filter((ee) => ee.hasOwnProperty('sucursal') && ee.sucursal !=null && ee.sucursal.hasOwnProperty('codigo') && ee.sucursal.codigo==V_USU.sucursal.codigo)
      }else{
          return RDocumento;
      }
      
    },

    
    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)
        this.newwnuevo()
      }
      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)
        this.ejecucion = true
        EventBus.$emit("loading", false)
      }
    },


    async filtro() {
      await this.$axios
        .get(
          this.$hostname + this.$hName + "/transferenciasInv/findall",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then(res => {
          this.list = res.data
        })
    },


    // abrirTabla2() {
    //   // console.log("entro");

    //   return !this.abrirTablaDinamica
    // }
  },

  computed: {

    ActDescBtn() {

      if (this.Tranferencia.transferenciasPK.secuencia > 0) {

        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: false,
          eliminar: false,
          anular: true,
          imprimir: true,
          vercuenta: true,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }

        if (this.Tranferencia.activada == false) {
          this.EstadoBtn.anular = false
        }


      }

      if (this.Tranferencia.transferenciasPK.secuencia <= 0) {


        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: true,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }
      }

      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))

    },

  },


}
</script>

<style></style>
